import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { scrollMargin })=>({
        scrollTarget: {
            scrollMarginTop: theme.px(scrollMargin)
        }
    }));
export { useStyles };
